import React, { ReactNode } from 'react';
import { baseRowHeight } from '../Table';
import cls from '../Table.module.scss';
import { TableDataItem } from '../types';
interface IProps {
  props?: any;
  rowHeight?: 'disabled' | number;
  tableDataSorted: TableDataItem[];
  children?: ReactNode;
}

const TrRender = ({ props, rowHeight, tableDataSorted, children }: IProps) => {
  const tableDataItem = tableDataSorted[props['data-index']];
  const tableDataStyle =
    rowHeight !== 'disabled'
      ? {
          height: rowHeight || baseRowHeight,
          ...(tableDataItem?.data?.style || {}),
        }
      : { ...(tableDataItem?.data?.style || {}) };
  return (
    <>
      {!tableDataSorted.length ? (
        <tr {...props} className={cls['table__tr-no-data']}></tr>
      ) : (
        <tr
          {...props}
          onDoubleClick={() => {
            tableDataItem.data.onEdit ? tableDataItem.data.onEdit() : null;
          }}
          onClick={(event) => tableDataItem.data?.onClick?.()}
          className={`${cls['table__tr-data']}
          ${tableDataItem.data?.isDisabled && 'table__tr-data--disabled'}
          ${tableDataItem.data?.className || ''}
        `}
          style={tableDataStyle}
        ></tr>
      )}
    </>
  );
};
// ${
//   selectedRows.includes(
//     tableDataItem.data.id
//   ) && 'table__tr-data--selected'
// }

export default TrRender;
